import { ChangeDetectorRef, Component, OnInit, SecurityContext, TemplateRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { SecureBlobPipe } from 'src/app/core/pipes/secure-blob.pipe';
import { isPublicImageUrl } from 'src/app/core/helpers/public-image-url.helper';
import { ToastrService } from 'ngx-toastr';
import { throwError } from 'rxjs';
import { ResourcesEndpointEnum } from 'src/app/core/enums/resources-endpoint.enum';
import { HelpPageInterface } from 'src/app/core/interfaces/help-page.interface';
import { ResourceService } from 'src/app/core/services/resource.service';
import { SearchService } from 'src/app/core/services/search.service';
import { IonicModule } from '@ionic/angular';
import { CommonModule, NgStyle } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-user-help-page',
    templateUrl: './user-help-page.component.html',
    styleUrls: ['./user-help-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    IonicModule,
    RouterLink,
    TranslateModule,
    CommonModule,
    NgStyle,
    SecureBlobPipe
]
})
export class UserHelpPageComponent implements OnInit {
  helpPageList: any;

  filteredHelpPages: HelpPageInterface[] = [];
  columns: Array<any> = [];

  showLoadingHelpPages = false;
  @ViewChild('helpPageTemplate', { static: true }) helpPageTemplate!: TemplateRef<any>;

  helpPages: any;

  constructor(private resourceService: ResourceService,
              private toastrService: ToastrService,
              private searchService: SearchService,
              private router: Router,
              private translateService: TranslateService,
              private sanitizer: DomSanitizer,
              private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.getUserHelpPages();
    this.cdr.detectChanges()

  }

  onSearch(event: any) {
    if(!event.target.value.toString().toLowerCase()) {
      this.getUserHelpPages();
    }
    const keys = ['Title', 'Description'];
    const arrays = ['Sections[Title]']
    this.helpPageList = this.searchService.searchFunction(keys, event, this.helpPageList, arrays);
  }

  initDataTable() {
    this.columns = [{
      cellTemplate: this.helpPageTemplate
    }];
  }

  redirectSection(section: any) {
    this.router.navigate(['home/help-pages-detail/' + section.HelpPageID], {queryParams: {section: section.Title}});
  }

  getUserHelpPages() {
    this.resourceService.getCollection<HelpPageInterface[]>(ResourcesEndpointEnum.GET_HELP_PAGES)
    .subscribe({
      next: (helpPage: HelpPageInterface[][]) => {
        this.helpPageList = helpPage;
        this.helpPageList.forEach((helpPage: any) => {
          helpPage.Sections = helpPage.Sections.filter((section: any) => section.Collapsable);
        });
        this.sortHelpPages();
        this.cdr.detectChanges()
      },
      error: (err) => {
        this.translateService.get('Error loading help pages').subscribe(t => {
          this.toastrService.error(t);
        })
        this.showLoadingHelpPages = false;
        throwError(() => err)
      },
      complete: () => {
        this.showLoadingHelpPages = false;
        }
      }
    );
  }
  private sortHelpPages() {
    this.helpPageList = this.helpPageList.sort((a: HelpPageInterface, b: HelpPageInterface) => {
      if (!a.Pinned && b.Pinned) {
          return 1;
      }
      if (a.Pinned && !b.Pinned) {
          return -1;
      }
  });
  }

  isPublicLogoUrl(url: string): boolean {
    return isPublicImageUrl(url);
  }

  // SafeUrl.toString() returns a security warning, not the URL, so unwrap it for CSS concatenation
  getBackgroundUrl(url: string | SafeUrl | null): string {
    return this.sanitizer.sanitize(SecurityContext.URL, url) ?? '';
  }
}
